import { Button, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useCallback, useMemo, useState } from "react";
import { useChecksReport } from "../hooks/useChecksReport";

type TChecksModeProps = {
  batchId: string;
  selectedDisbursementIds: React.Key[];
  setSelectedDisbursementIds: React.Dispatch<React.SetStateAction<React.Key[]>>;
  setIsChecksModeOn: React.Dispatch<React.SetStateAction<boolean>>;
  onMethodChange: (value: number) => void;
  onAssignClick: () => void;
  reloadData: () => void;
};

export const ChecksModeHeader = ({
  batchId,
  selectedDisbursementIds,
  setSelectedDisbursementIds,
  setIsChecksModeOn,
  onMethodChange,
  onAssignClick,
  reloadData,
}: TChecksModeProps) => {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const { printChecksReport } = useChecksReport(
    batchId,
    reloadData,
    setIsDownloading,
    selectedDisbursementIds
  );

  const onCancel = useCallback(() => {
    setIsChecksModeOn(false);
    setSelectedDisbursementIds([]);
    onMethodChange(0);
  }, [onMethodChange, setIsChecksModeOn, setSelectedDisbursementIds]);

  const headerLabel: string = useMemo(
    () =>
      selectedDisbursementIds.length !== 0
        ? "Default sorting order will be used for the actions"
        : "Select a Check",
    [selectedDisbursementIds]
  );

  return (
    <Row className="w-100 justify-space-between check-mode">
      <Row className="align-center">
        <h5 className="h h5 mr-4 ant-table-title">Checks</h5>
        <p className="ma-0 text-md title">{headerLabel}</p>
      </Row>
      <Row>
        {selectedDisbursementIds.length !== 0 && (
          <Row className="align-center pr-6 additional-actions">
            <p className="ma-0">
              {selectedDisbursementIds.length} Check Selected
            </p>
            <Button shape="round" className="mx-4" onClick={onAssignClick}>
              Assign #
            </Button>
            <Button
              shape="round"
              disabled={isDownloading}
              onClick={printChecksReport}
            >
              Print
            </Button>
          </Row>
        )}
        <Button
          shape="circle"
          icon={<CloseOutlined />}
          onClick={onCancel}
          className="ml-6"
        />
      </Row>
    </Row>
  );
};
